"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnDeclarationInlineErrorToJSON = exports.ReturnDeclarationInlineErrorFromJSONTyped = exports.ReturnDeclarationInlineErrorFromJSON = void 0;
var _1 = require("./");
function ReturnDeclarationInlineErrorFromJSON(json) {
    return ReturnDeclarationInlineErrorFromJSONTyped(json, false);
}
exports.ReturnDeclarationInlineErrorFromJSON = ReturnDeclarationInlineErrorFromJSON;
function ReturnDeclarationInlineErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'trackingData': (json['trackingData'].map(_1.ReturnDeclarationInlineErrorTrackingDataFromJSON)),
    };
}
exports.ReturnDeclarationInlineErrorFromJSONTyped = ReturnDeclarationInlineErrorFromJSONTyped;
function ReturnDeclarationInlineErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'trackingData': (value.trackingData.map(_1.ReturnDeclarationInlineErrorTrackingDataToJSON)),
    };
}
exports.ReturnDeclarationInlineErrorToJSON = ReturnDeclarationInlineErrorToJSON;
//# sourceMappingURL=ReturnDeclarationInlineError.js.map